import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';

const StyledRadioRoot = styled(Radio)({
  marginRight: '12px',
  color: '#000000',
  '&.ccg-Mui-checked': {
    color: '#316BBE',
  },
});

export default StyledRadioRoot;
